// 直播模式忽略的插件
export const onLineIgnores = [
  'Fullscreen',
  'Start',
  'progress',
  'progresspreview',
  'definition',
  'PlaybackRate',
  'miniscreen',
];

// 点播模式忽略的插件
export const recordIgnores = ['Fullscreen', 'Start', 'definition'];

export const customLang = {
  LANG: 'zh-cn',
  TEXT: {
    // 不支持的音频/视频格式
    MEDIA_ERR_SRC_NOT_SUPPORTED: '不支持的视频格式',
    CSSFULLSCREEN_TIPS: '全屏',
    EXITCSSFULLSCREEN_TIPS: '退出全屏',
  },
};
